import { Button } from "@/components/ui/Button";

interface ApprovalActionsProps {
  onApprove: () => void;
  onRegenerate: () => void;
  onReject: () => void;
  disabled?: boolean;
}

export function ApprovalActions({
  onApprove,
  onRegenerate,
  onReject,
  disabled,
}: ApprovalActionsProps) {
  return (
    <div className="flex gap-2 shrink-0">
      <Button variant="danger" onClick={onReject} disabled={disabled}>
        Rechazar
      </Button>
      <Button variant="secondary" onClick={onRegenerate} disabled={disabled}>
        Regenerar
      </Button>
      <Button variant="primary" onClick={onApprove} disabled={disabled}>
        Aprobar
      </Button>
    </div>
  );
}
